{
    "version": "4.3.1",
    "update_info": {
        "date": "2025-08-06 11:01:41"
    },
    "indexedDB": {
        "stable_version": 1,
        "old_store_names": [
            "NGRX Storage"
        ]
    },
    "external_cdns": {
        "jsonEditorMinCss": "https://cdn.jsdelivr.net/npm/jsoneditor/dist/jsoneditor.min.css"
    }
}